import {SkeletonLineWrapper} from '../../../common/components/Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';
import React from 'react';
import {classes, st} from './TotalUpdateSkeleton.st.css';

export enum TotalUpdateSkeletonDataHooks {
  Loader = 'TotalUpdateSkeletonDataHooks.Loader',
}

export const TotalUpdateSkeleton = ({size}: {size?: 'small' | 'medium'}) => (
  <SkeletonLineWrapper
    dataHook={TotalUpdateSkeletonDataHooks.Loader}
    className={st(classes.skeleton, size && classes[size])}
  />
);
